import __base_store from '@/store/__base_store'

/**
 * Store de bodegas (modelo `bodega`).
 * Construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'bodega',
	},
})

